// @ts-nocheck

import React, { ReactElement, useEffect, useState, useCallback } from 'react';
import { faSearch, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import Color from 'octa-front-sdk/dist/enums/Color';
import CategoriesFilterStyles from './styles';

import InputIcon from '../../../components/InputIcon';
import BtnIcon from '../../../components/BtnIcon';

interface IProps {
  categories: string[];
  nameFiltered: (name: string) => void;
}

const CategoriesFilter: React.FC<IProps> = (props): ReactElement => {
  const { categories, nameFiltered } = props;
  const [width, setWidth] = useState(window.innerWidth);
  const [activeIndex, setActiveIndex] = useState(0);
  const [clientRect, setClientRect] = useState();
  const [isFixed, setIsFixed] = useState(false);
  const [filteredByName, setFilteredByName] = useState('');
  const [isInputApearing, setIsInputApearing] = useState(false);

  const isHiRes = width >= 1280;

  useEffect((): (() => void) => {
    const handleResize = (): void => {
      const filter = document.getElementById('filter');

      if (filter) {
        setClientRect(filter.getBoundingClientRect());
      }

      setWidth(window.innerWidth);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return (): void => window.removeEventListener('resize', handleResize);
  }, [setWidth, setClientRect]);

  const scrollHandler = useCallback((): void => {
    const filter = document.getElementById('filter');

    if (filter && clientRect) {
      let scrollPosition = document.documentElement.scrollTop;

      if (isHiRes) scrollPosition += 80;

      const isFixed = scrollPosition > clientRect.top;

      setIsFixed(isFixed);
    }
  }, [setIsFixed, clientRect, isHiRes]);

  useEffect((): (() => void) => {
    document.addEventListener('scroll', scrollHandler);

    return (): void => document.removeEventListener('scroll', scrollHandler);
  }, [isHiRes, scrollHandler]);

  const scrollToCategory = useCallback(
    (index: number): void => {
      const element = Array.from(document.getElementsByTagName('div')).filter(
        (d): boolean => d.innerHTML === categories[index],
      )[0];

      if (element) {
        const topOffset = 80;
        const elementTop = element.getBoundingClientRect().top;
        const documentTop = document.documentElement.getBoundingClientRect()
          .top;
        const y = elementTop - documentTop - topOffset;

        window.scrollTo({ top: y, behavior: 'smooth' });
      }

      setActiveIndex(index);
    },
    [categories],
  );

  function filterByName(value: string): void {
    nameFiltered(value);
    setFilteredByName(value);
  }

  function showInput(): void {
    setIsInputApearing(!isInputApearing);
  }

  function clearSearch(): void {
    showInput();
    filterByName('');
  }

  return (
    <CategoriesFilterStyles.Container>
      <CategoriesFilterStyles.Content id="filter" isFixed={isFixed}>
        {isHiRes && (
          <CategoriesFilterStyles.FilterTitle>
            Busca por categorias
          </CategoriesFilterStyles.FilterTitle>
        )}

        <CategoriesFilterStyles.CategoriesListWrapper>
          <CategoriesFilterStyles.CategoriesList>
            <CategoriesFilterStyles.CategoriesListInputFilter
              showInput={isInputApearing}
            >
              <BtnIcon
                onClick={showInput}
                icon={faSearch}
                color={Color.BlueGrey600}
              />
              <InputIcon
                placeholder="Filtrar por nome"
                name="nameFilter"
                value={filteredByName}
                onChange={(e): void => filterByName(e.target.value)}
                btnFunction={clearSearch}
                btnIcon={faTimesCircle}
              />
            </CategoriesFilterStyles.CategoriesListInputFilter>
            {categories.map(
              (category, index): ReactElement => {
                return (
                  <CategoriesFilterStyles.Category
                    key={index}
                    className={index === activeIndex ? 'active' : ''}
                    onClick={(): void => scrollToCategory(index)}
                  >
                    {category}
                  </CategoriesFilterStyles.Category>
                );
              },
            )}
          </CategoriesFilterStyles.CategoriesList>
        </CategoriesFilterStyles.CategoriesListWrapper>
      </CategoriesFilterStyles.Content>
    </CategoriesFilterStyles.Container>
  );
};

export default CategoriesFilter;
